import React from 'react'
import InspectorGantt from '../InspectorGantt'

function FilterGhanttChart() {
  return (
	  <InspectorGantt editMode={false} />
  )
}

export default FilterGhanttChart